import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridModule, SelectionEvent } from '@progress/kendo-angular-grid';

import { UsersListComponent } from './users-list.component';
import{ ModalModule } from '../../../../common/component/modal/modal.module';
import { AddEditUserModule } from './add-edit-user/add-edit-user.module';

@NgModule({
  imports: [
    CommonModule
    ,GridModule
    ,ModalModule
    ,AddEditUserModule
  ],
  declarations: [UsersListComponent],
  exports: [UsersListComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UsersListModule { }
